import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./alerts-actions.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * DeveloperApi class.
 */
export default class AlertsActionsApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.alertsActions;
    }

    /**
     * Get developer application config
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

    /**
     * Create application
     * @returns {promise}
     */
    create(rule) { // eslint-disable-line
        // TODO: should be refactoring with real API
        const returnedRule = {
            title: rule.title,
            id: Math.floor(Math.random() * 1000000000000000000),
            type: rule.type,
        };

        const promise = new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(returnedRule);
                reject('Error');
            }, 1000);
        });

        return promise;
    }

    /**
     * Update application
     * @returns {promise}
     */
    remove(rule) { // eslint-disable-line
        const promise = new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(rule);
                reject('Error');
            }, 1000);
        });

        return promise;
    }
}



// WEBPACK FOOTER //
// ./app/services/api/alerts-actions/alerts-actions.service.js